import { convertDate } from './convert-date.function';

export function offsetDateToUtc(date: string | Date) {
  const dateObj = convertDate(date);
  const utcDateObj = new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60000);

  return utcDateObj;
}

export function offsetDateFromUtc(date: string | Date) {
  const dateObj = convertDate(date);
  const utcDateObj = new Date(dateObj.getTime() - dateObj.getTimezoneOffset() * 60000);

  return utcDateObj;
}
